import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { takePkce, useAuth } from "./AuthContext";
import { exchangeCodeForTokens } from "./tokens";

export default function Callback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { completeSignIn } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const errParam = params.get("error");
    if (errParam) {
      setError(`${errParam}: ${params.get("error_description") ?? "no description"}`);
      return;
    }

    const code = params.get("code");
    const state = params.get("state");
    const pending = takePkce();

    if (!code || !state || !pending || pending.state !== state) {
      setError("Invalid auth callback — state mismatch or missing code. Try signing in again.");
      return;
    }

    exchangeCodeForTokens(code, pending.verifier)
      .then((tokens) => {
        completeSignIn(tokens);
        navigate(pending.returnTo && pending.returnTo !== "/auth/callback" ? pending.returnTo : "/", {
          replace: true,
        });
      })
      .catch((e: Error) => setError(e.message));
  }, [params, navigate, completeSignIn]);

  return (
    <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center">
      <div className="text-center max-w-md">
        {error ? (
          <>
            <h1 className="text-2xl font-bold text-red-400 mb-2">Sign-in failed</h1>
            <p className="text-gray-400 text-sm">{error}</p>
            <button
              type="button"
              onClick={() => navigate("/", { replace: true })}
              className="mt-6 px-4 py-2 bg-orange-500 hover:bg-orange-600 rounded text-white"
            >
              Back to home
            </button>
          </>
        ) : (
          <p className="text-gray-400">Signing you in...</p>
        )}
      </div>
    </div>
  );
}
